import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import {Link} from "react-router-dom";

const ModalButtons = ({step, back, next}) => {
    return (
        <div className={"modal-buttons-container"}>
            <div className={"container-left"}>
                {
                    step > 1 ?
                        <button className={"text-button"} onClick={() => back()}>
                            BACK
                        </button>
                        : null
                }
            </div>
            <div className={"container-right"}>
                <Link to={`/${globalThis.location.search}`}>
                    <button className={"text-button text-button-cancel"}>
                        CANCEL
                    </button>
                </Link>
                {
                    step < 3 ?
                        <button className={"text-button"} onClick={() => next()} >
                            NEXT
                        </button>
                        :
                        <button className={"text-button"} onClick={() => next()}>
                            DONE
                        </button>
                }
            </div>
        </div>
    );
}

ModalButtons.propTypes = {
    step: PropTypes.number.isRequired,
    back: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
};

export default ModalButtons;